import { render, staticRenderFns } from "./MaterialArticle.vue?vue&type=template&id=7ef5530f"
import script from "./MaterialArticle.vue?vue&type=script&lang=js"
export * from "./MaterialArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports